module.exports = new __parcel__URL__("khotynenko.57fd1ce3.jpg").toString();